import { render, staticRenderFns } from "./sharePoup.vue?vue&type=template&id=08228745&"
import script from "./sharePoup.vue?vue&type=script&lang=js&"
export * from "./sharePoup.vue?vue&type=script&lang=js&"
import style0 from "./sharePoup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports